/*! Copyright (c) 2022, XAPPmedia */

import { ChatMessageRequest, ChatMessageRequestCustom } from "../xapp/ChatServerMessage";
import { StentorRequest } from "./http-utils";

import { UserProfile } from "stentor-models";
import { VisitorInfo } from "../xapp/StentorRouterChat";

const PERMISSION_QUESTION_EXPIRATION_MS = 300000; // 5 minutes

export function requestFromMessage(
    message: ChatMessageRequest,
    userId: string,
    isNewSession: boolean,
    sessionId: string,
    accessToken: string,
    attributes: Record<string, unknown>,
    visitorInfo: VisitorInfo
): StentorRequest {
    let request;

    const now = new Date().getTime();

    if (isNewSession && !message?.msg?.text) {
        request = {
            type: "LAUNCH_REQUEST",
            rawQuery: message?.msg?.text,
            sessionId,
            userId,
            isNewSession: true,
            intentId: "LaunchRequest",
            platform: "stentor-platform",
            channel: "widget",
            accessToken,
            attributes
        };
    } else {
        // Pending permission request?

        const permissionRequest = message.msg?.permissionRequest;

        if (permissionRequest) {
            message = {
                ...message,
                msg: {
                    ...message.msg,
                    permissionRequest: undefined
                }
            };
            const expired = now - permissionRequest.time > PERMISSION_QUESTION_EXPIRATION_MS;

            const text = message.msg.text?.toLowerCase();

            let granted = !expired;

            const userProfile: UserProfile = { id: userId };
            if (!expired) {
                if (permissionRequest.type === "EMAIL") {
                    const isEmail = looksLikeEmail(text);
                    granted = isEmail;
                    userProfile.email = visitorInfo.email;
                    userProfile.name = visitorInfo.displayName;
                    this.visitorInfo.email = text;
                }
                if (permissionRequest.type === "LOCATION_PRECISE") {
                    granted = !!message.msg.location;
                        userProfile.preciseLocation = message.msg.location ? {
                              coordinates: {
                                  latitude: message.msg.location.latitude,
                                longitude: message.msg.location.longitude
                            }
                        } as undefined : undefined;
                }
            }

            request = {
                type: "PERMISSION_GRANT",
                rawQuery: message.msg.text,
                sessionId: sessionId,
                userId: userId,
                isNewSession: false,
                granted,
                userProfile,
                intentId: "PermissionGrant",
                platform: "stentor-platform",
                channel: "widget",
                accessToken,
                attributes,
            };

        } else if (message.type === "custom") {
            request = {
                ...JSON.parse((message as ChatMessageRequestCustom).payload),
                // token: message.msg.token,
                sessionId: sessionId,
                userId: userId,
                isNewSession: false,
                // intentId: "OptionSelect",
                platform: "stentor-platform",
                channel: "widget",
                accessToken,
                attributes,
            };
        } else if (message.msg.token) {
            request = {
                type: "OPTION_SELECT_REQUEST",
                token: message.msg.token,
                sessionId: sessionId,
                userId: userId,
                isNewSession: false,
                intentId: "OptionSelect",
                platform: "stentor-platform",
                channel: "widget",
                accessToken,
                attributes,
            };
        } else {
            request = {
                type: "INTENT_REQUEST",
                rawQuery: message.msg.text,
                sessionId: sessionId,
                userId: userId,
                isNewSession: false,
                intentId: "NLU_RESULT_PLACEHOLDER",
                platform: "stentor-platform",
                channel: "widget",
                accessToken,
                attributes,
            };
        }
    }

    if (message.msg?.attributes) {
        request.attributes = { ...request.attributes, ...message.msg.attributes };
    }

    return request;
}

function looksLikeEmail(email: string) {
    const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(String(email).toLowerCase());
}

